<template>
    <a-card :title="$t('screenTitle.siteConfig')">
        <a-collapse>
            <a-collapse-panel header="Cài đặt khuyến mãi khi chuyển BẠC CHÍNH vào game">
                <a-form ref="formPromotionTransInfo" :model="formModelPromotionTransInfo" @finish="onFinishPromotionTransInfo"
                    :rules="formRulePromotionTransInfo" :scrollToFirstError="true" layout="vertical">
                    <a-form-item label="Tỉ lệ (%)" name="rate">
                        <a-input-number v-model:value="formModelPromotionTransInfo.rate" :min="1" />
                    </a-form-item>
                    <a-form-item label="Phạm vi thời gian" name="range">
                        <a-range-picker v-model:value="formModelPromotionTransInfo.range" show-time />
                    </a-form-item>

                    <a-form-item>
                        <a-button type="primary" html-type="submit" block :loading="isLoadingPromotionTransInfo">{{
                            $t('text.save') }}</a-button>
                    </a-form-item>
                </a-form>
            </a-collapse-panel>
            <a-collapse-panel header="Cài đặt phiên bản client Game.exe">
                <a-form ref="formGameExeVer" :model="formModelGameExeVer" @finish="onFinishGameExeVer"
                    :rules="formRuleGameExeVer" :scrollToFirstError="true" layout="vertical">
                    <a-form-item label="Mã phiên bản" name="value">
                        <a-input v-model:value="formModelGameExeVer.value" placeholder="06 85 00 00" />
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" html-type="submit" block :loading="isLoadingGameExeVer">{{
                            $t('text.save') }}</a-button>
                    </a-form-item>
                </a-form>
            </a-collapse-panel>
            <a-collapse-panel header="Cài link tải game">
                <a-form ref="formDlUrls" :model="formModelDlUrls" @finish="onFinishDlUrls" :rules="formRuleDlUrls"
                    :scrollToFirstError="true" layout="vertical">
                    <a-form-item label="Các địa chỉ tải game" name="value" help="Mỗi địa chỉ cách nhau 1 dòng">
                        <a-textarea v-model:value="formModelDlUrls.value" :rows="5"
                            placeholder="Google 1|http://google.com/xxx" />
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" html-type="submit" block :loading="isLoadingDlUrls">{{
                            $t('text.save') }}</a-button>
                    </a-form-item>
                </a-form>
            </a-collapse-panel>
            <a-collapse-panel header="Liên kết Server Game">
                <a-table :dataSource="dataSourceServers" :columns="columnsServers" :pagination="false"
                    :loading="isLoadingServers">
                    <template #bodyCell="{ column, record }">
                        <template v-if="column.key === 'action'">
                            <a-space>
                                <a-button type="primary" danger @click="() => onDeleteServer(record)">
                                    <template #icon>
                                        <DeleteOutlined />
                                    </template>
                                </a-button>
                            </a-space>
                        </template>
                        <template v-else-if="column.dataIndex === 'allow_unlock_char'">
                            <a-checkbox v-model:checked="record.allow_unlock_char"
                                @change="() => onServerChangeUnlock(record)" />
                        </template>
                    </template>
                </a-table>
                <a-collapse ghost>
                    <a-collapse-panel header="Liên kết máy chủ Game mới">
                        <a-alert>
                            <template #description>
                                <a href="https://docs.google.com/spreadsheets/d/1y1N-_at6dlV-n1HSlsesMpDx8xKd7O-NNw-UKmCv0e0/edit#gid=985197945&range=B20"
                                    target="_blank">Xem hướng dẫn</a>
                            </template>
                        </a-alert>
                        <a-form ref="formCreateServer" :model="formModelCreateServer" @finish="onFinishCreateServer"
                            :rules="formRuleCreateServer" :scrollToFirstError="true" layout="vertical">
                            <a-form-item label="Tên máy chủ" name="name">
                                <a-input v-model:value="formModelCreateServer.name" />
                            </a-form-item>

                            <a-form-item label="db_host" name="db_host">
                                <a-input v-model:value="formModelCreateServer.db_host" />
                            </a-form-item>

                            <a-form-item label="db_port" name="db_port">
                                <a-input-number v-model:value="formModelCreateServer.db_port" :min="1" :max="65535" />
                            </a-form-item>

                            <a-form-item label="db_user" name="db_user">
                                <a-input v-model:value="formModelCreateServer.db_user" />
                            </a-form-item>

                            <a-form-item label="db_pass" name="db_pass">
                                <a-input v-model:value="formModelCreateServer.db_pass" />
                            </a-form-item>

                            <a-form-item label="db_name" name="db_name">
                                <a-input v-model:value="formModelCreateServer.db_name" />
                            </a-form-item>

                            <a-form-item label="login_port" name="login_port">
                                <a-input-number v-model:value="formModelCreateServer.login_port" :min="1"
                                    :max="65535" />
                            </a-form-item>

                            <a-form-item>
                                <a-button type="primary" html-type="submit" block :loading="isLoadingServers">{{
                                    $t('text.save') }}</a-button>
                            </a-form-item>
                        </a-form>
                    </a-collapse-panel>
                </a-collapse>
            </a-collapse-panel>
            <a-collapse-panel header="Cài đặt thời gian đua top chuyển BẠC CHÍNH vào game">
                <a-form ref="formTopTransRange" :model="formModelTopTransRange" @finish="onFinishTopTransRange"
                    :rules="formRuleTopTransRange" :scrollToFirstError="true" layout="vertical">
                    <a-form-item label="Phạm vi thời gian" name="value">
                        <a-range-picker v-model:value="formModelTopTransRange.value" show-time />
                    </a-form-item>

                    <a-form-item>
                        <a-button type="primary" html-type="submit" block :loading="isLoadingTopTransRange">{{
                            $t('text.save') }}</a-button>
                    </a-form-item>
                </a-form>
                <a-table
                    :columns="[{ title: 'Tên tài khoản', dataIndex: 'accname' }, { title: 'Bạc', dataIndex: 'coin'}]"
                    :data-source="topTransferToTlbb"
                    :loading="isLoadingTopTrans"
                >
                    <template #title><a-button :loading="isLoadingTopTrans" @click="fetchTopTransferTlbb">Load lại danh sách top</a-button></template>
                </a-table>
            </a-collapse-panel>
        </a-collapse>
    </a-card>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, } from "vue";
import { useI18n } from "vue-i18n";

import { Alert, Button, Card, Checkbox, Collapse, DatePicker, Form, Input, InputNumber, message, Modal, Space, Table, } from "ant-design-vue";
import { DeleteOutlined, } from '@ant-design/icons-vue';
import { RuleObject } from "ant-design-vue/lib/form";
import { ColumnType } from "ant-design-vue/lib/table";

import { RouteName } from "@/router";
import ApiRequest from "@/utils/ApiRequest";
import { DateType } from "@/utils/types";
import dayjs from "dayjs";

interface FormModelPromotionTransInfo {
    rate?: number;
    range?: [DateType, DateType];
}

interface FormModelTopTransRange {
    value?: [DateType, DateType];
}

interface FormModelGameExeVer {
    value: string;
}

interface FormModelDlUrls {
    value: string;
}

interface FormModelCreateServer {
    name: string;
    db_host: string;
    db_port?: number;
    db_user: string;
    db_pass: string;
    db_name: string;
    login_port?: number;
}

export default defineComponent({
    components: {
        ACard: Card,
        AButton: Button,
        AAlert: Alert,
        AForm: Form,
        AFormItem: Form.Item,
        AInput: Input,
        ATextarea: Input.TextArea,
        AInputNumber: InputNumber,
        ACollapse: Collapse,
        ACollapsePanel: Collapse.Panel,
        ATable: Table,
        ASpace: Space,
        ACheckbox: Checkbox,
        ARangePicker: DatePicker.RangePicker,

        DeleteOutlined,
    },

    setup() {
        const { t } = useI18n();

        const isLoadingServers = ref(true);
        const dataSourceServers = ref([]);
        const columnsServers: ColumnType[] = [
            {
                title: 'Tên máy chủ',
                dataIndex: 'name',
            },
            {
                title: 'Cho phép mở khoá nhân vật',
                dataIndex: 'allow_unlock_char',
            },
            {
                title: t('text.action'),
                key: 'action',
            },
        ];
        const fetchServers = () => {
            isLoadingServers.value = true;

            ApiRequest.get('/site-configs/servers')
                .then(res => {
                    dataSourceServers.value = res.data.data;
                })
                .finally(() => {
                    isLoadingServers.value = false;
                });
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const onServerChangeUnlock = (record: any) => {
            isLoadingServers.value = true;
            ApiRequest.post(`/site-configs/servers/${record.id}/set-unlock-char/${record.allow_unlock_char ? 1 : 0}`)
                .then(() => {
                    message.success(t('message.success'));
                })
                .finally(() => {
                    fetchServers();
                })
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const onDeleteServer = (record: any) => {
            Modal.confirm({
                title: t('message.deleteConfirmContent'),
                content: `${record.name}`,
                onOk: async () => {
                    isLoadingServers.value = true;
                    return ApiRequest.del(`/servers/${record.id}`)
                        .then(() => {
                            message.success(t('message.deleteSuccess'));
                        })
                        .finally(() => {
                            fetchServers();
                        })
                },
            });
        };

        const formCreateServer = ref<typeof Form>();
        const formModelCreateServer = reactive<FormModelCreateServer>({
            name: '',
            db_host: '',
            // db_port: 6,
            db_user: '',
            db_pass: '',
            db_name: '',
            // login_port: 1,
        });
        const formExtraErrorCreateServer: Record<keyof FormModelCreateServer, string> = {
            name: '',
            db_host: '',
            db_port: '',
            db_user: '',
            db_pass: '',
            db_name: '',
            login_port: '',
        };
        const formRuleCreateServer = reactive<Record<keyof FormModelCreateServer, RuleObject[]>>({
            name: [
                {
                    required: true,
                    trigger: 'change',
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorCreateServer.name || undefined),
                },
            ],
            db_host: [
                {
                    required: true,
                    trigger: 'change',
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorCreateServer.db_host || undefined),
                },
            ],
            db_port: [
                {
                    required: true,
                    trigger: 'change',
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorCreateServer.db_port || undefined),
                },
            ],
            db_user: [
                {
                    required: true,
                    trigger: 'change',
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorCreateServer.db_user || undefined),
                },
            ],
            db_pass: [
                {
                    required: true,
                    trigger: 'change',
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorCreateServer.db_pass || undefined),
                },
            ],
            db_name: [
                {
                    required: true,
                    trigger: 'change',
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorCreateServer.db_name || undefined),
                },
            ],
            login_port: [
                {
                    required: true,
                    trigger: 'change',
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorCreateServer.login_port || undefined),
                },
            ],
        });
        const onFinishCreateServer = (values: FormModelCreateServer) => {
            isLoadingServers.value = true;
            ApiRequest.post('/servers', {
                ...values,
                db_port: values.db_port?.toString(),
            }).then(() => {
                message.success(t('message.createSuccess'));

                formCreateServer.value?.resetFields();
            })
                .catch(err => {
                    ApiRequest.handleError(err, formExtraErrorCreateServer, formCreateServer.value);
                    isLoadingServers.value = true;
                })
                .finally(() => {
                    fetchServers();
                });
        };

        const isLoadingDlUrls = ref(true);
        const formDlUrls = ref<typeof Form>();
        const formModelDlUrls = reactive<FormModelDlUrls>({
            value: '',
        });
        const formExtraErrorDlUrls: Record<keyof FormModelDlUrls, string> = {
            value: '',
        };
        const formRuleDlUrls = reactive<Record<keyof FormModelDlUrls, RuleObject[]>>({
            value: [
                {
                    required: true,
                    trigger: 'change',
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorDlUrls.value || undefined),
                },
            ],
        });
        const fetchDlUrls = () => {
            isLoadingDlUrls.value = true;

            ApiRequest.get('/site-configs/download-urls')
                .then(res => {
                    formModelDlUrls.value = res.data.data;
                })
                .finally(() => {
                    isLoadingDlUrls.value = false;
                });
        };
        const onFinishDlUrls = (values: FormModelDlUrls) => {
            isLoadingDlUrls.value = true;
            ApiRequest.post('/site-configs/download-urls', values).then(() => {
                message.success(t('message.saveSuccess'));
            })
                .catch(err => {
                    ApiRequest.handleError(err, formExtraErrorDlUrls, formDlUrls.value);
                    isLoadingDlUrls.value = true;
                })
                .finally(() => {
                    fetchDlUrls();
                });
        };

        const isLoadingPromotionTransInfo = ref(true);
        const formPromotionTransInfo = ref<typeof Form>();
        const formModelPromotionTransInfo = reactive<FormModelPromotionTransInfo>({
            rate: undefined,
            range: undefined,
        });
        const formExtraErrorPromotionTransInfo: Record<keyof FormModelPromotionTransInfo, string> = {
            rate: '',
            range: '',
        };
        const formRulePromotionTransInfo = reactive<Record<keyof FormModelPromotionTransInfo, RuleObject[]>>({
            rate: [
                {
                    required: true,
                    trigger: 'change',
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorPromotionTransInfo.rate || undefined),
                },
            ],
            range: [
                {
                    required: true,
                    trigger: 'change',
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorPromotionTransInfo.range || undefined),
                },
            ],
        });
        const fetchPromotionTransInfo = () => {
            isLoadingPromotionTransInfo.value = true;

            ApiRequest.get('/site-configs/promotion-transfer-to-tlbb')
                .then(res => {
                    formModelPromotionTransInfo.rate = res.data.data?.rate;
                    formModelPromotionTransInfo.range = res.data.data?.range?.map((item:string) => {
                        return dayjs(item);
                    });
                })
                .finally(() => {
                    isLoadingPromotionTransInfo.value = false;
                });
        };
        const onFinishPromotionTransInfo = (values: FormModelPromotionTransInfo) => {
            isLoadingPromotionTransInfo.value = true;
            ApiRequest.post('/site-configs/promotion-transfer-to-tlbb', {
                ...values,
                range: [values.range?.[0]?.format('YYYY-MM-DD HH:mm:ss'), values.range?.[1]?.format('YYYY-MM-DD HH:mm:ss')],
            }).then(() => {
                message.success(t('message.saveSuccess'));
            })
                .catch(err => {
                    ApiRequest.handleError(err, formExtraErrorPromotionTransInfo, formPromotionTransInfo.value);
                    isLoadingPromotionTransInfo.value = true;
                })
                .finally(() => {
                    fetchPromotionTransInfo();
                });
        };

        const isLoadingTopTransRange = ref(true);
        const formTopTransRange = ref<typeof Form>();
        const formModelTopTransRange = reactive<FormModelTopTransRange>({
            value: undefined,
        });
        const formExtraErrorTopTransRange: Record<keyof FormModelTopTransRange, string> = {
            value: '',
        };
        const formRuleTopTransRange = reactive<Record<keyof FormModelTopTransRange, RuleObject[]>>({
            value: [
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorTopTransRange.value || undefined),
                },
            ],
        });
        const fetchTopTransRange = () => {
            isLoadingTopTransRange.value = true;

            ApiRequest.get('/site-configs/top-transfer-to-tlbb-date-range')
                .then(res => {
                    formModelTopTransRange.value = res.data.data?.map((item:string) => {
                        return dayjs(item);
                    });
                })
                .finally(() => {
                    isLoadingTopTransRange.value = false;
                });
        };
        const onFinishTopTransRange = (values: FormModelTopTransRange) => {
            isLoadingTopTransRange.value = true;
            ApiRequest.post('/site-configs/top-transfer-to-tlbb-date-range', {
                value: [values.value?.[0]?.format('YYYY-MM-DD HH:mm:ss'), values.value?.[1]?.format('YYYY-MM-DD HH:mm:ss')],
            }).then(() => {
                message.success(t('message.saveSuccess'));
            })
                .catch(err => {
                    ApiRequest.handleError(err, formExtraErrorTopTransRange, formTopTransRange.value);
                    isLoadingTopTransRange.value = true;
                })
                .finally(() => {
                    fetchTopTransRange();
                });
        };

        const isLoadingGameExeVer = ref(true);
        const formGameExeVer = ref<typeof Form>();
        const formModelGameExeVer = reactive<FormModelGameExeVer>({
            value: '',
        });
        const formExtraErrorGameExeVer: Record<keyof FormModelDlUrls, string> = {
            value: '',
        };
        const formRuleGameExeVer = reactive<Record<keyof FormModelGameExeVer, RuleObject[]>>({
            value: [
                {
                    required: true,
                    trigger: 'change',
                },
                {
                    validator: (_rule, _value, callback) => callback(formExtraErrorGameExeVer.value || undefined),
                },
            ],
        });
        const fetchGameExeVer = () => {
            isLoadingGameExeVer.value = true;

            ApiRequest.get('/site-configs/game-exe-ver')
                .then(res => {
                    formModelGameExeVer.value = res.data.data;
                })
                .finally(() => {
                    isLoadingGameExeVer.value = false;
                });
        };
        const onFinishGameExeVer = (values: FormModelGameExeVer) => {
            isLoadingGameExeVer.value = true;
            ApiRequest.post('/site-configs/game-exe-ver', values).then(() => {
                message.success(t('message.saveSuccess'));
            })
                .catch(err => {
                    ApiRequest.handleError(err, formExtraErrorGameExeVer, formGameExeVer.value);
                    isLoadingGameExeVer.value = true;
                })
                .finally(() => {
                    fetchGameExeVer();
                });
        };

        const isLoadingTopTrans = ref(false);
        const topTransferToTlbb = ref([]);
        const fetchTopTransferTlbb = () => {
            isLoadingTopTrans.value = true;
            ApiRequest.get('/site-configs/top-transfer-to-tlbb').then((res) => {
                topTransferToTlbb.value = res.data.data;
            })
            .finally(() => {
                isLoadingTopTrans.value = false;
            });
        };

        onMounted(() => {
            fetchPromotionTransInfo();
            fetchTopTransRange();
            fetchGameExeVer();
            fetchDlUrls();
            fetchServers();
            fetchTopTransferTlbb();
        });

        return {
            isLoadingServers,
            dataSourceServers,
            columnsServers,
            onServerChangeUnlock,
            onDeleteServer,

            formCreateServer,
            formModelCreateServer,
            formRuleCreateServer,
            onFinishCreateServer,

            isLoadingDlUrls,
            formDlUrls,
            formModelDlUrls,
            formRuleDlUrls,
            onFinishDlUrls,

            isLoadingTopTransRange,
            formTopTransRange,
            formModelTopTransRange,
            formRuleTopTransRange,
            onFinishTopTransRange,

            isLoadingGameExeVer,
            formGameExeVer,
            formModelGameExeVer,
            formRuleGameExeVer,
            onFinishGameExeVer,

            isLoadingPromotionTransInfo,
            formPromotionTransInfo,
            formModelPromotionTransInfo,
            formRulePromotionTransInfo,
            onFinishPromotionTransInfo,

            topTransferToTlbb,
            isLoadingTopTrans,
            fetchTopTransferTlbb,

            RouteName,
        };
    },
})
</script>

<style scoped>

</style>
